import React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Container, Downloads } from '@uncinc/uncinc-react-kitchen-sink';
import type { LinkProps } from '@uncinc/uncinc-react-kitchen-sink/dist/organisms/Downloads';
import type { DownloadProps } from '@uncinc/uncinc-react-kitchen-sink/dist/components/Download';

import type { ParagraphDownloads as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphDownloadsProps {
  id?: string;
  entity: ImmutableEntity<Type>;
  noBootstrap?: boolean;
}

const ParagraphDownloads: React.FC<ParagraphDownloadsProps> = ({
  id,
  entity,
  noBootstrap = false,
}) => {
  const paragraphDownloads = entity.toJS();

  const title = paragraphDownloads.field_title[0]?.value;
  const body = paragraphDownloads.field_body[0]?.processed;
  const link = paragraphDownloads.field_link?.[0];
  const linkUrl = link?.alias || link?.uri;
  const linkTitle = link?.title;
  const secondaryLink = paragraphDownloads.field_link_secondary?.[0];
  const secondaryLinkUrl = secondaryLink?.alias || secondaryLink?.uri;
  const secondaryLinkTitle = secondaryLink?.title;
  const downloads = paragraphDownloads.field_items;

  const downloadItems = downloads.map((download): DownloadProps | undefined => {
    const file = download.entity?.field_media_document[0];

    if (!file) {
      return undefined;
    }

    return {
      source: file.source,
      title: download.title,
      image: download.entity?.field_thumbnail[0]?.styles.ratio_a4_xxs ?? '/sites/default/files/download-placeholder.png',
      description: download.entity?.field_description[0]?.value,
      filesize: download.file_size,
      filename: file.filename,
      mime: download.mime_type,
    };
  }).filter(Boolean) as DownloadProps[];

  return (
    <div id={id} className="Paragraph ParagraphDownloads">
      <Container>
        <div className="row">
          <div className={noBootstrap ? 'col-12' : 'col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2'}>
            <Downloads
              title={title}
              text={body}
              downloads={downloadItems}
              materialIconName="file_download"
              target="_blank"
              links={[
                linkUrl && linkTitle ? {
                  href: linkUrl,
                  title: linkTitle,
                } : undefined,
                secondaryLinkUrl && secondaryLinkTitle ? {
                  href: secondaryLinkUrl,
                  title: secondaryLinkTitle,
                } : undefined,
              ].filter(Boolean) as LinkProps[]}
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphDownloads;
